import { gql } from '@apollo/client';

export const validateApplicablePromocode = gql`
  query validateApplicablePromocode($id: String, $promoCodes: [PromoCode]) {
    entitlementDetails(id: $id) {
      promoCodesApplicable(promoCodes: $promoCodes) {
        promotionId
        redeemedCount
        maxRedemptions
        promotions {
          id
          title
          maxRedemptions
          promotionCodeType
          benefits {
            benefitType
            duration
            subBenefitType
            iterations
            value
            scale
            type
            customisable {
              value {
                type
                lowerBound
                upperBound
              }
              iterations {
                type
                lowerBound
                upperBound
              }
              duration
            }
          }
          promotionWindow {
            endTime
            startTime
          }
          status
          cycleInterval
          pricingType
          eligibilityRules {
            products
            cycleInterval
            pricingType
            partnerType
            partnerTier
            saleTransitionType
            currency
          }
          applicationReason {
            id
            readableName
            customisable {
              id {
                type
                anyOf {
                  readableName
                  id
                }
              }
            }
          }
          customisableReasons {
            readableName
            id
          }
          isPromotionCustomisable
          type
        }
        notApplicablePromotionCodesWithReason
      }
    }
  }
`;
